/**
 * StyleX styles for the AppSidebar component.
 *
 * Contains only base styles (brand, user info, header controls).
 * Collapse state transitions are handled by sidebar-collapse.css.
 */

import * as stylex from "@stylexjs/stylex";

import {
  colors,
  fontSize,
  fontWeight,
  radius,
  space,
} from "@animus/primaris/tokens.stylex";

export const styles = stylex.create({
  headerRow: {
    display: "flex",
    alignItems: "center",
  },

  userProfile: {
    display: "flex",
    alignItems: "center",
    gap: space.sm,
    minWidth: 0,
  },

  userInfoContainer: {
    overflow: "hidden",
    flexShrink: 1,
    minWidth: 0,
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  userName: {
    fontSize: fontSize.sm,
    fontWeight: fontWeight.medium,
    color: colors.foreground,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  userEmail: {
    fontSize: fontSize["2xs"],
    color: colors.foregroundMuted,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  signInPlaceholder: {
    width: 32,
    height: 32,
    borderRadius: radius.full,
    backgroundColor: colors.muted,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: fontSize.sm,
    color: colors.foregroundMuted,
    flexShrink: 0,
  },
  signInButton: {
    backgroundColor: "transparent",
    borderWidth: 0,
    cursor: "pointer",
    textAlign: "left",
    opacity: 0.8,
    ":hover": {
      opacity: 1,
    },
  },
  signInInfo: {
    display: "flex",
    flexDirection: "column",
    whiteSpace: "nowrap",
  },
  signInTitle: {
    fontSize: fontSize.sm,
    fontWeight: fontWeight.medium,
    color: colors.foreground,
  },
  signInSubtitle: {
    fontSize: fontSize["2xs"],
    color: colors.foregroundMuted,
  },

  settingsContainer: {
    flexShrink: 0,
    overflow: "hidden",
  },
});
